/**
 * Created by lyasovich on 10.12.2014.
 */
Ext.ns('mx.comp');

mx.comp.PeriodFieldMS = Ext.extend(mx.comp.FieldGroup, {
    spinnerWidth: 70,
    errorMessage: '',
    spinnerStrategy: {
        xtype: 'number',
        minValue: 0,
    },
    spinnerDefaultValue: 0,
    allowBlank: false,
    comboWidth: 90,
    comboDataFields: ['interval_id', 'interval_name'],
    labels: {
        milliseconds: 'milliseconds',
        seconds: 'seconds',
        minutes: 'minutes',
        hours: 'hours',
        days: 'days',
        weeks: 'week',
    },
    comboData: null,
    comboDefaultValue: 'h',
    comboValueField: 'interval_id',
    comboDisplayField: 'interval_name',
    textWidth: 1.0,
    text: '',
    isFieldContainer: false,
    minValue: 0,
    comboDisabled: false,
    comboHidden: false,

    validator: function() {
        return true;
    },

    isDirty: function() {
        if (this.disabled) {
            return false;
        }
        return String(this.getValue()) !== String(this.originalValue);
    },

    onChange: function() {
        this.fireEvent('change', this);
    },

    initComponent: function() {
        var thiz = this;

        this.comboData = this.comboData || [
            ['ms', MXBT.get('LOC')['mx.comp.PeriodField']['milliseconds'] || this.labels.milliseconds],
            ['s', MXBT.get('LOC')['mx.comp.PeriodField']['seconds'] || this.labels.seconds],
            ['m', MXBT.get('LOC')['mx.comp.PeriodField']['minutes'] || this.labels.minutes],
            ['h', MXBT.get('LOC')['mx.comp.PeriodField']['hours'] || this.labels.hours],
            ['d', MXBT.get('LOC')['mx.comp.PeriodField']['days'] || this.labels.days],
            ['w', MXBT.get('LOC')['mx.comp.PeriodField']['weeks'] || this.labels.weeks],
        ];

        mx.comp.PeriodField.superclass.initComponent.call(this);

        this.addEvents('change');

        this.columns = [this.spinnerWidth, this.comboWidth, this.textWidth];

        this.defaults = {
            anchor: '-5',
        };

        if (!this.comboStore) {
            this.comboStore = new Ext.data.SimpleStore({
                fields: this.comboDataFields,
                data: this.comboData,
            });
        }

        this.name = this.name || this.id;

        if (this.allowBlank) {
            this.spinnerDefaultValue = null;
        }

        this.items = [
            (this.spinner = new Ext.ux.form.Spinner({
                scope: this,
                strategy: this.spinnerStrategy,
                name: this.name + '-value',
                value: this.spinnerDefaultValue,
                allowBlank: this.allowBlank,
                validateValue: function() {
                    var sv = this.scope.getValue();
                    if (sv > this.scope.maxValue || sv < this.scope.minValue) {
                        this.errorMessage = 'Invalid value';
                        this.markInvalid(this.scope.errorMessage);
                        return false;
                    }
                    if (this.scope.validator(this.getValue())) {
                        this.clearInvalid();
                        return true;
                    } else {
                        this.markInvalid(this.scope.errorMessage);
                        return false;
                    }
                },
                onBlur: function() {
                    if (this.allowBlank && this.getValue() == '') {
                        return;
                    } else if (this.strategy.fixBoundries) {
                        this.setValue(this.strategy.fixBoundries(this.getValue()));
                    }
                },
                listeners: {
                    change: function() {
                        thiz.setValue(thiz.calcValueInMilliseconds(thiz.spinner.el.dom.value));
                        thiz.onChange();
                    },
                },
            })),
            (this.combo = new Ext.form.ComboBox({
                name: this.name + '-interval',
                mode: 'local',
                editable: false,
                forceSelection: true,
                triggerAction: 'all',
                valueField: this.comboValueField,
                displayField: this.comboDisplayField,
                store: this.comboStore,
                value: this.comboDefaultValue,
                disabled: this.comboDisabled,
                plugins: new mx.plugin.hideableField({visibilityMode: Ext.Element.DISPLAY}),
                initiallyHidden: this.comboHidden,
                listeners: {
                    select: function() {
                        thiz.onChange();
                    },
                },
            })),
            (this.textLabel = {
                xtype: 'label',
                text: this.text,
            }),
        ];
    },

    // тест версии с миллисекундами
    setValue: function(/*int*/ milliseconds, interval) {
        if (isNaN(parseInt(milliseconds)) && this.allowBlank) return;

        var multiplier;
        if (interval) {
            this.setUnits(interval);
            multiplier = this.getMillisecondsMultiplier();
        } else {
            var allowWeek = false;
            var allowDay = false;
            var allowHour = false;
            var allowMinute = false;
            var allowSeconds = false;
            var allowMilliseconds = false;
            for (var i = 0; i < this.comboData.length; i++) {
                if (this.comboData[i][0] == 'ms') {
                    allowMilliseconds = true;
                }
                if (this.comboData[i][0] == 's') {
                    allowSeconds = true;
                }
                if (this.comboData[i][0] == 'm') {
                    allowMinute = true;
                }
                if (this.comboData[i][0] == 'h') {
                    allowHour = true;
                }
                if (this.comboData[i][0] == 'd') {
                    allowDay = true;
                }
                if (this.comboData[i][0] == 'w') {
                    allowWeek = true;
                }
            }

            if (allowMinute && milliseconds == 0) {
                // Для настроек по умолчанию используются минуты
                this.combo.setValue('m');
                multiplier = 1 / (1000 * 60);
            } else if (allowMilliseconds && milliseconds < 1000) {
                // миллисекунды
                this.combo.setValue('ms');
                multiplier = 1;
            } else if (allowSeconds && milliseconds < 1000 * 60) {
                // секунды
                this.combo.setValue('s');
                multiplier = 1 / 1000;
            } else if (allowMinute && milliseconds < 1000 * 60 * 60) {
                // минуты
                this.combo.setValue('m');
                multiplier = 1 / (1000 * 60);
            } else if (allowHour && milliseconds < 1000 * 60 * 60 * 24) {
                // часы
                this.combo.setValue('h');
                multiplier = 1 / (1000 * 60 * 60);
            } else if (allowDay && milliseconds < 1000 * 60 * 60 * 24 * 7) {
                // дни
                this.combo.setValue('d');
                multiplier = 1 / (1000 * 60 * 60 * 24);
            } else if (allowWeek) {
                // недели
                this.combo.setValue('w');
                multiplier = 1 / (1000 * 60 * 60 * 24 * 7);
            }
        }
        milliseconds = milliseconds.toString().replace(',', '.');
        this.spinner.setValue(Math.round(milliseconds * multiplier * 100) / 100 || 0);
        this.validate();
    },

    getValue: function() {
        return this.calcValueInMilliseconds(this.spinner.getValue());
    },

    getMillisecondsMultiplier: function() {
        var u = this.combo.getValue();
        switch (u) {
            case 'ms': {
                return 1;
            }
            case 's': {
                return 1 / 1000;
            }
            case 'm': {
                return 1 / 60 / 1000;
            }
            case 'h': {
                return 1 / 3600 / 1000;
            }
            case 'd': {
                return 1 / 3600 / 24 / 1000;
            }
            case 'w': {
                return 1 / 3600 / 24 / 7 / 1000;
            }
        }
        return 0;
    },

    getUnits: function() {
        var u = this.combo.getValue();
        switch (u) {
            case 'ms': {
                return 1;
            }
            case 's': {
                return 2;
            }
            case 'm': {
                return 3;
            }
            case 'h': {
                return 4;
            }
            case 'd': {
                return 5;
            }
            case 'w': {
                return 6;
            }
        }
        return 0;
    },

    setUnits: function(u) {
        switch (u) {
            case 1: {
                this.combo.setValue('ms');
                break;
            }
            case 2: {
                this.combo.setValue('s');
                break;
            }
            case 3: {
                this.combo.setValue('m');
                break;
            }
            case 4: {
                this.combo.setValue('h');
                break;
            }
            case 5: {
                this.combo.setValue('d');
                break;
            }
            case 6: {
                this.combo.setValue('w');
                break;
            }
            default:
                this.combo.setValue('h');
                break;
        }
    },
    calcValueInMilliseconds: function(v) {
        if ((v == null || v == '') && this.allowBlank) return null;

        var mult = 0;
        var interval = this.combo.getValue();
        switch (interval) {
            case 'ms': {
                mult = 1;
                break;
            }
            case 's': {
                mult = 1000;
                break;
            }
            case 'm': {
                mult = 1000 * 60;
                break;
            }
            case 'h': {
                mult = 1000 * 3600;
                break;
            }
            case 'd': {
                mult = 1000 * 3600 * 24;
                break;
            }
            case 'w': {
                mult = 1000 * 3600 * 24 * 7;
                break;
            }
        }
        return Math.round(MXBT.parseDouble(v) * mult) || 0;
    },

    getName: function() {
        return this.name;
    },

    setText: function(text) {
        this.textLabel.text = text;
    },

    validate: function() {
        if (!this.allowBlank && !this.spinner.validate()) {
            this.spinner.markInvalid(this.blankText);
            return false;
        } else {
            this.spinner.clearInvalid();
            return true;
        }
    },
});

Ext.reg('mx_periodfieldms', mx.comp.PeriodFieldMS);
